module.exports = __webpack_public_path__ + "assets/img/cpp_test_l4.0f50d695.png";